export default __webpack_public_path__ + "static/media/Capture.7bdbfef0.PNG";